import { ExtendAction } from '../types';
import { CreateLyceeState } from '../reducers/createLycee.reducer';
import { CreateClasseState } from '../reducers/createClasse.reducer';

export const CREATE_CLASSE = 'CREATE_CLASSE';
export type SetClasseFormAction = ExtendAction<
  CreateClasseState,
  typeof CREATE_CLASSE
>;

export const setClasseForm = (
  payload: CreateClasseState
): SetClasseFormAction => {
  return {
    type: CREATE_CLASSE,
    payload
  };
};

export const CREATE_LYCEE = 'CREATE_LYCEE';
export type SetLyceeFormAction = ExtendAction<
  CreateLyceeState,
  typeof CREATE_LYCEE
>;

export const setLyceeForm = (payload: CreateLyceeState): SetLyceeFormAction => {
  return {
    type: CREATE_LYCEE,
    payload
  };
};

export type CreateLyceeClasseActions = SetLyceeFormAction | SetClasseFormAction;
